var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"picker",staticClass:"wt-area-picker-stage shape-point",class:_vm.classObj,style:(_vm.styleObj),attrs:{"tabindex":_vm.index},on:{"mousedown":_vm.onMouseDown,"keydown":_vm.move}},[_c('div',{staticClass:"shape"},[_vm._v("+")])])}
var staticRenderFns = []

export { render, staticRenderFns }